/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Preview_Line_TwoInputs */

const en_highlight_settings_preview_line_two = /** @type {(inputs: Highlight_Settings_Preview_Line_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The whole line or section background reflects your selected mode.`)
};

const es_highlight_settings_preview_line_two = /** @type {(inputs: Highlight_Settings_Preview_Line_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El fondo de la línea o sección refleja el modo elegido.`)
};

/**
* | output |
* | --- |
* | "The whole line or section background reflects your selected mode." |
*
* @param {Highlight_Settings_Preview_Line_TwoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_preview_line_two = /** @type {((inputs?: Highlight_Settings_Preview_Line_TwoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Preview_Line_TwoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_preview_line_two(inputs)
	return en_highlight_settings_preview_line_two(inputs)
});